import config from "@/config"
import http from "@/utils/request"
export default {
	ExportSalaryTemplate: {
		url: `${config.API_URL}/CiticUserSalary/ExportSalaryTemplate`,
		name: "保存用户信息",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	ImportSalary: {
		url: `${config.API_URL}/CiticUserSalary/ImportSalary`,
		name: "保存用户信息",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	OrgSalary: {
		url: `${config.API_URL}/CiticUserSalary/OrgSalary`,
		name: "提交银行发放",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	UpdateSalaryPan: {
		url: `${config.API_URL}/CiticUserSalary/UpdateSalaryPan`,
		name: "修改银行卡号",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
}
